import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { IcepackStateFormView } from './icepack-state-view';
import { getFormInitialValuesSelector } from '../../selectors';
import { ICEPACK_STATE_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const IcepackStateFormWrapper = ({ isLoading }) => {
	return <IcepackStateFormView isLoading={isLoading} />;
};

const withForm = reduxForm({
	form: ICEPACK_STATE_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(IcepackStateFormWrapper);

const mapStateToProps = createStructuredSelector({
	initialValues: getFormInitialValuesSelector(),
});

IcepackStateFormWrapper.propTypes = {
	initialValues: PropTypes.object,
	isLoading: PropTypes.bool.isRequired,
};

const IcepackStateForm = connect(mapStateToProps)(withForm);

export { IcepackStateForm };
